exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.list-name[data-v-e681b1f2]{\n    margin-right: 10px;\n}\n.notification-status[data-v-e681b1f2]{\n    font-size: 20px;\n    line-height: 20px;\n}\n", ""]);

// exports
